import React from "react";

export const FilmGrain = () => {
  return <div className="film-grain" data-testid="film-grain-overlay" aria-hidden="true" />;
};

export default FilmGrain;
